"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const interfaces_1 = require("./interfaces");
const item_1 = require("./item");
class ExtendedNavBar extends React.PureComponent {
    get style() {
        return {
            top: 0,
            height: (this.props.height + 1) + "px",
            left: 0,
            right: 0,
            position: "relative",
            background: this.props.background,
            display: "flex",
        };
    }
    render() {
        return (
        /**El primer div se usa para ocupar espacio en la pagina pero el que se dibuja en realidad es el 2do div */
        React.createElement("div", { style: this.style },
            React.createElement("div", { style: {
                    background: interfaces_1.dark,
                    display: "flex",
                    flex: "1 0 auto",
                    color: this.props.color
                } },
                React.createElement("div", { style: { flex: "0 1 auto" } },
                    this.props.header && this.props.header.map((x, i) => item_1.mapNavBarItem(false, this.props.height, undefined, x, i)),
                    this.props.left && this.props.left.map((x, i) => item_1.mapNavBarItem(false, this.props.height, undefined, x, i))),
                React.createElement("div", { style: { flex: "1 0 auto" } }),
                React.createElement("div", null, this.props.right && this.props.right.map((x, i) => item_1.mapNavBarItem(false, this.props.height, undefined, x, i))))));
    }
}
class Burger extends React.Component {
    render() {
        const spanStyle = {
            height: "3px",
            background: this.props.color,
            width: "20px",
            margin: "3px 2px 3px 2px"
        };
        return (React.createElement("div", { style: { display: "inline-block" } },
            React.createElement("div", { style: spanStyle }),
            React.createElement("div", { style: spanStyle }),
            React.createElement("div", { style: spanStyle })));
    }
}
class CollapsedNavBar extends React.Component {
    constructor(props) {
        super(props);
        this.mapItem = (x, i) => item_1.mapNavBarItem(true, this.props.height, this.handleCollapse, x, i);
        this.handleExpand = () => {
            this.setState(prev => ({ expanded: !prev.expanded }));
        };
        this.handleCollapse = () => {
            this.setState({ expanded: false });
        };
        this.state = { expanded: false };
    }
    render() {
        return (React.createElement("div", { style: { top: 0, left: 0, right: 0, color: this.props.color } },
            React.createElement("div", { style: { position: "relative", top: 0, bottom: 0, left: 0, right: 0, background: this.props.background } },
                React.createElement("div", { style: {
                        background: interfaces_1.dark,
                        display: "flex",
                        flexDirection: "column"
                    } },
                    React.createElement("div", null,
                        React.createElement("div", { style: { flex: "0 1 auto" } },
                            React.createElement("div", null,
                                React.createElement("div", { style: { display: "flex" } },
                                    React.createElement("div", { style: { flex: "1 0 auto" } }, this.props.header && this.props.header.map(this.mapItem)),
                                    React.createElement("div", { onClick: this.handleExpand, style: { flex: "0 0 auto", display: "flex", justifyContent: "center", flexDirection: "column" } },
                                        React.createElement(Burger, { color: this.props.color }))))),
                        React.createElement("div", { style: { flex: "1 0 auto" } })),
                    this.state.expanded &&
                        React.createElement("div", null,
                            this.props.left && this.props.left.map(this.mapItem),
                            this.props.right && this.props.right.map(this.mapItem))))));
    }
}
class NavBarContainer extends React.Component {
    render() {
        return (this.props.collapsed ?
            React.createElement(CollapsedNavBar, Object.assign({}, this.props))
            : React.createElement(ExtendedNavBar, Object.assign({}, this.props)));
    }
}
exports.NavBarContainer = NavBarContainer;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/navbar/bars.js
// module id = 2241
// module chunks = 0